module.exports = __webpack_public_path__ + "static/media/maatregelen.c0c4af5d.jpg";